import { render, staticRenderFns } from "./RatingPCCTable.vue?vue&type=template&id=38bd765c&"
import script from "./RatingPCCTable.vue?vue&type=script&lang=js&"
export * from "./RatingPCCTable.vue?vue&type=script&lang=js&"
import style0 from "./RatingPCCTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports